import { useEffect, useState } from 'react';

// import Editor from 'rich-markdown-editor';

import { HocuspocusProvider } from '@hocuspocus/provider';
import * as Y from 'yjs';
import { useCollaborationContext } from './CollaborationContext';

export function useCollaboration(documentName: string) {
  const [doc, setDoc] = useState<Y.Doc | null>();
  const [canRender, setCanRender] = useState(false);
  const [provider, setProvider] = useState<HocuspocusProvider | null>(null);

  const { socket } = useCollaborationContext();

  useEffect(() => {
    const ydoc = new Y.Doc();

    const prov = new HocuspocusProvider({
      websocketProvider: socket,
      name: documentName,
      document: ydoc,
    });

    setProvider(prov);
    setDoc(ydoc);

    prov.on('synced', () => {
      setCanRender(true);
    });

    return () => {
      setCanRender(false);
      prov.disconnect();
      prov.destroy();
      ydoc.destroy();
      setProvider(null);
      setDoc(null);
    };
  }, [documentName, socket]);

  return {
    canRender,
    provider,
    doc,
  };
}
